import VanlifeRoadtrips from 'elem/compPage/VanlifeRoadtrips';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/vanlife-roadtrips';
import SEOlinksA from '@/components/SEOlinksA';

export default function VanlifeRoadtripsPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!['us', 'ca', 'de', 'za', 'fr', 'uk', 'eu', 'it', 'es', 'au', 'kr'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <VanlifeRoadtrips />
        </PageLayout>
    );
}
